export class ResultModel {
    resultvalue:string;
    
    constructor(){
        this.resultvalue = '';
        
    }
}
